import { z } from 'zod/v4';

import { createdAtSchemaLegacy, styleBagSchema } from '../../../common/schemas/legacy';

import { videoLegacyDefaultDataSchema } from './data';

/**
 * Default-placement legacy video envelope.
 *
 * `type` is `z.literal('default').optional()` so that:
 *  - persisted entities written before the discriminator existed (which omit
 *    `type` entirely) still parse here, and
 *  - the zod discriminated union in `./entity.ts` can dispatch on `type` —
 *    `.optional()` is allowed inside `z.discriminatedUnion` and falls through
 *    to this branch when the field is missing.
 *
 * Inner data uses {@link videoLegacyDefaultDataSchema} — the simplified
 * `horizontalPosition` + `maxWidth` layout shorthand. The zero variant
 * (see `./zero.ts`) uses an entirely different data shape.
 */
export const videoLegacyDefaultV0Schema = z.object({
    id: z.string(),
    name: z.literal('video'),
    columnId: z.string(),
    structureId: z.string().nullish(),
    displayId: z.string().optional(),
    createdAt: createdAtSchemaLegacy,
    type: z.literal('default').optional(),
    data: videoLegacyDefaultDataSchema,
    styles: styleBagSchema.nullish(),
    mobileStyles: styleBagSchema.nullish(),
});
